import { useCallback, useEffect, useState } from 'react';

export const wrapGalleryIndex = (index, count) => count > 0
  ? ((index % count) + count) % count
  : 0;

// The gallery component is keyed by the record slug, so route changes reset it.
export const useGallery = (images) => {
  const [index, setIndex] = useState(0);
  const [open, setOpen] = useState(false);
  const count = images.length;
  const activeIndex = wrapGalleryIndex(index, count);
  const previous = useCallback(() => {
    setIndex((current) => wrapGalleryIndex(current - 1, count));
  }, [count]);
  const next = useCallback(() => {
    setIndex((current) => wrapGalleryIndex(current + 1, count));
  }, [count]);
  const select = useCallback((position) => {
    setIndex(wrapGalleryIndex(position, count));
  }, [count]);
  const openAt = useCallback((position) => {
    select(position);
    setOpen(count > 0);
  }, [count, select]);

  useEffect(() => {
    if (!open) return undefined;
    const onKey = (event) => {
      if (event.key === 'ArrowLeft') { event.preventDefault(); previous(); }
      if (event.key === 'ArrowRight') { event.preventDefault(); next(); }
    };
    window.addEventListener('keydown', onKey);
    return () => window.removeEventListener('keydown', onKey);
  }, [open, previous, next]);

  return { activeIndex, image: images[activeIndex], count, open, setOpen, select, openAt, previous, next };
};